jQuery(function ($) {
  var mobileMenu = $('.mobile-wrap');
  var lineBurger = $('.line-burger');
  var headerList = $('.header__list');

  if (!mobileMenu.length || !lineBurger.length || !headerList.length) {
    return;
  }

  mobileMenu.off('click.lasemanMenu').on('click.lasemanMenu', function() {
    lineBurger.toggleClass('line-active');
    headerList.slideToggle();
  });

  $(window).off('resize.lasemanMenu').on('resize.lasemanMenu', function() {
    if ($(window).width() > 1350) {
      headerList.attr('style', '');
      lineBurger.removeClass('line-active');
    }
  });
});

var testimonialsSlider = document.querySelector('.testimonials__slider');

if (testimonialsSlider && !testimonialsSlider.swiper && typeof Swiper !== 'undefined') {
  new Swiper(testimonialsSlider, {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      1350: {
        slidesPerView: 3,
        spaceBetween: 40
      }
    },
    navigation: {
      nextEl: '.testimonials__arrow-next',
      prevEl: '.testimonials__arrow-prev'
    }
  });
}
